import useUserStore from '@/store/modules/user';
import { getProBusinessFuelBagConfig, getProBusinessSubscribeConfig } from '@/config/proConfig'
export const useLocalBuy = () => {
    const { locale } = useI18n()
    const userStore = useUserStore()
    let coinKey = userStore.getCurrentCoin(locale.value)
    const vipItems = ref(getProBusinessSubscribeConfig(coinKey))
    const bagItems = ref(getProBusinessFuelBagConfig(coinKey))

    watch(() => locale.value, () => {
        coinKey = userStore.getCurrentCoin(locale.value)
        vipItems.value = getProBusinessSubscribeConfig(coinKey)
        bagItems.value = getProBusinessFuelBagConfig(coinKey)
    })

    return {
        vipItems,
        bagItems
    }
}   